export const IMG_BASE = '/assets/bottle-mania/BottleMania/Images'
export const SOUND_BASE = '/assets/bottle-mania/BottleMania/Sound'
export const DESIGN_WIDTH = 756
export const DESIGN_HEIGHT = 1344
export const BET_ITEM_WIDTH = 123

export const BOTTLE_COLORS = ['Red', 'Green', 'Blue']

export const BOTTLE_MODES = [
  {
    id: 'low',
    color: 'Blue',
    label: 'Low',
    maxOdds: 100,
    maxLabel: 'x100',
    liquid: '#2B9DFF',
    exponent: 0.2,
    tickMs: 100
  },
  {
    id: 'medium',
    color: 'Red',
    label: 'Medium',
    maxOdds: 1000,
    maxLabel: 'x1,000',
    liquid: '#FF3B4E',
    exponent: 0.25,
    tickMs: 200
  },
  {
    id: 'high',
    color: 'Green',
    label: 'High',
    maxOdds: 50000,
    maxLabel: 'x50,000',
    liquid: '#2EE36A',
    exponent: 0.3,
    tickMs: 150
  }
]

export const ASSETS = {
  bg: `${IMG_BASE}/Start/Background.png`,
  purpleLayer: `${IMG_BASE}/Mobile/Start/PurpleLayer.png`,
  betsContainer: `${IMG_BASE}/Start/betsContainer.png`,
  pressArrow: `${IMG_BASE}/Start/pressAndHoldArrow.png`,
  menu: `${IMG_BASE}/Start/Menu.png`,
  menuHover: `${IMG_BASE}/Start/MenuHover.png`,
  lobby: `${IMG_BASE}/Start/Lobby.png`,
  lobbyHover: `${IMG_BASE}/Start/LobbyHover.png`,
  close: `${IMG_BASE}/Start/Close.png`,
  closeHover: `${IMG_BASE}/Start/CloseHover.png`,
  howToPlayBg: `${IMG_BASE}/HowToPlay/Background.png`,
  howToPlayOk: `${IMG_BASE}/HowToPlay/OkButton.png`,
  howToPlayOkHover: `${IMG_BASE}/HowToPlay/OkButtonHover.png`,
  check: `${IMG_BASE}/HowToPlay/CheckCircle.png`,
  checkOn: `${IMG_BASE}/HowToPlay/Selected.png`,
  arrowLeft: `${IMG_BASE}/Buttons/ArrowLeft.png`,
  arrowLeftActive: `${IMG_BASE}/Buttons/ArrowLeftActive.png`,
  arrowRight: `${IMG_BASE}/Buttons/ArrowRight.png`,
  arrowRightActive: `${IMG_BASE}/Buttons/ArrowRightActive.png`,
  holdGreen: `${IMG_BASE}/Buttons/Green.png`,
  holdBlue: `${IMG_BASE}/Buttons/Blue.png`,
  holdRed: `${IMG_BASE}/Buttons/Red.png`,
  autoplay: `${IMG_BASE}/Buttons/AutoPlay-Button.png`,
  autoplayHover: `${IMG_BASE}/Buttons/AutoPlay-Button-Hover.png`,
  autoplayStop: `${IMG_BASE}/Buttons/AutoPlay-Button-Stop.png`,
  stats: `${IMG_BASE}/Buttons/Statistics.png`,
  statsHover: `${IMG_BASE}/Buttons/Statistics-Hover.png`,
  autoplayBg: `${IMG_BASE}/Autoplay/AutoPlay-Big-Bg.png`,
  autoplayCounter: `${IMG_BASE}/Autoplay/AutoPlay-Counter.png`,
  statsTop: `${IMG_BASE}/Statistics/Statistic-Top-BG.png`,
  statsBottom: `${IMG_BASE}/Statistics/Statistic-Bottom-BG.png`,
  statsWin: `${IMG_BASE}/Statistics/Statistic-Win-Passive.png`,
  statsWinHover: `${IMG_BASE}/Statistics/Statistic-Win-Passive-Hover.png`,
  statsWinActive: `${IMG_BASE}/Statistics/Statistic-Win-Active.png`,
  statsWinActiveHover: `${IMG_BASE}/Statistics/Statistic-Win-Active-Hover.png`,
  statsGreen: `${IMG_BASE}/Statistics/Statistic-GreenBottle.png`,
  statsBlue: `${IMG_BASE}/Statistics/Statistic-BlueBottle.png`,
  statsRed: `${IMG_BASE}/Statistics/Statistic-RedBottle.png`,
  insufficient: `${IMG_BASE}/Errors/BalanceError.png`,
  soundPopup: `${IMG_BASE}/Errors/Popup.png`,
  loaderLogo: '/assets/bottle-mania/Common/Images/loader-logo.gif',
  menuIcon: '/assets/bottle-mania/Common/Images/Buttons/icon.png',
  menuIconActive: '/assets/bottle-mania/Common/Images/Buttons/icon-active.png',
  menuExit: '/assets/bottle-mania/Common/Images/Buttons/exit.png',
  menuExitHover: '/assets/bottle-mania/Common/Images/Buttons/exit-hover.png',
  menuFullscreen: '/assets/bottle-mania/Common/Images/Buttons/fullscreen.png',
  menuFullscreenHover: '/assets/bottle-mania/Common/Images/Buttons/fullscreen-hover.png',
  menuFullscreenActive: '/assets/bottle-mania/Common/Images/Buttons/fullscreen-active.png',
  menuFullscreenActiveHover: '/assets/bottle-mania/Common/Images/Buttons/fullscreen-active-hover.png',
  menuMusicOn: '/assets/bottle-mania/Common/Images/Buttons/background-sound-on.png',
  menuMusicOnHover: '/assets/bottle-mania/Common/Images/Buttons/background-sound-on-hover.png',
  menuMusicOff: '/assets/bottle-mania/Common/Images/Buttons/background-sound-off.png',
  menuMusicOffHover: '/assets/bottle-mania/Common/Images/Buttons/background-sound-off-hover.png',
  menuSoundOn: '/assets/bottle-mania/Common/Images/Buttons/sound-active.png',
  menuSoundOnHover: '/assets/bottle-mania/Common/Images/Buttons/sound-active-hover.png',
  menuSoundOff: '/assets/bottle-mania/Common/Images/Buttons/sound.png',
  menuSoundOffHover: '/assets/bottle-mania/Common/Images/Buttons/sound-hover.png',
  menuHelp: '/assets/bottle-mania/Common/Images/Buttons/help.png',
  menuHelpHover: '/assets/bottle-mania/Common/Images/Buttons/help-hover.png'
}

export const HOLD_BUTTON_SRC = {
  Green: ASSETS.holdGreen,
  Blue: ASSETS.holdBlue,
  Red: ASSETS.holdRed
}

export const DEFAULT_BOTTLE_MODE = 'high'

export const getBottleMode = (modeId = DEFAULT_BOTTLE_MODE) => (
  BOTTLE_MODES.find((mode) => mode.id === modeId) || BOTTLE_MODES[2]
)

export const getBottleModeByColor = (color) => (
  BOTTLE_MODES.find((mode) => mode.color === color) || BOTTLE_MODES[2]
)

export const getBottleColor = (modeId) => getBottleMode(modeId).color

export const getAdjacentColors = (color) => {
  const index = BOTTLE_COLORS.indexOf(color)
  const safeIndex = index < 0 ? 1 : index
  return {
    left: BOTTLE_COLORS[(safeIndex + BOTTLE_COLORS.length - 1) % BOTTLE_COLORS.length],
    right: BOTTLE_COLORS[(safeIndex + 1) % BOTTLE_COLORS.length]
  }
}

export const bottleImg = (file) => `${IMG_BASE}/Bottles/${file}`
export const coeffImg = (color) => `${IMG_BASE}/Coeffs/${color}Bottle${color}Coeffs.png`
export const numberImg = (file) => `${IMG_BASE}/Mobile/Wins/Numbers/${file}`

export const GAME_PHASE = {
  IDLE: 'idle',
  PLAYING: 'playing',
  WON: 'won',
  LOST: 'lost'
}

export const HOW_TO_PLAY_STORAGE_KEY = 'bottle-mania-hide-how-to-play'
